"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertStringToNumber = exports.getDecimalSeparator = exports.isTablet = exports.isMobile = exports.getBowserState = exports.draggingMotion = exports.getInnerWidth = exports.getOuterWidth = exports.getElement = exports.getWindowHeight = exports.getWindowWidth = exports.getWindowLocationOrigin = exports.setDataAttribute = exports.getDataAttribute = void 0;
/**
 * Commonly used functions for cross browser window, document, or html attribute manipulation
 */
const window_or_global_1 = __importDefault(require("window-or-global"));
/**
 * Function to get the data attribute that is compatible with IE
 * @param element
 * @param attributeName
 */
function getDataAttribute(element, attributeName) {
    if (!element || !attributeName)
        return null;
    return element.dataset ? element.dataset[attributeName] : element.getAttribute(`data-${attributeName}`);
}
exports.getDataAttribute = getDataAttribute;
function setDataAttribute(element, attributeName, value) {
    if (!element || !attributeName || !value)
        return null;
    if (element.dataset) {
        element.dataset[attributeName] = value;
    }
    else {
        element.setAttribute(`data-${attributeName}`, value);
    }
    return 1;
}
exports.setDataAttribute = setDataAttribute;
/**
 * Function to get root.location.origin that is compatible with IE 9/10
 */
function getWindowLocationOrigin() {
    if (!window_or_global_1.default.location.origin) {
        const port = window_or_global_1.default.location.port ? `:${window_or_global_1.default.location.port}` : '';
        window_or_global_1.default.location.origin = `${window_or_global_1.default.location.protocol}//${window_or_global_1.default.location.hostname}${port}`;
        return window_or_global_1.default.location.origin;
    }
    return window_or_global_1.default.location.origin;
}
exports.getWindowLocationOrigin = getWindowLocationOrigin;
const getWindowWidth = () => {
    const innerWindowWidth = window_or_global_1.default.innerWidth;
    const clientWidth = window_or_global_1.default.document.documentElement.clientWidth || window_or_global_1.default.document.getElementsByTagName('body')[0].clientWidth;
    if (clientWidth < innerWindowWidth) {
        return innerWindowWidth; //accounts for scroll bars
    }
    return clientWidth; //accounts for pinch to zoom
};
exports.getWindowWidth = getWindowWidth;
const getWindowHeight = () => {
    const innerHeight = window_or_global_1.default.innerHeight;
    const clientHeight = window_or_global_1.default.document.documentElement.clientHeight || window_or_global_1.default.document.getElementsByTagName('body')[0].clientHeight;
    if (clientHeight < innerHeight) {
        return innerHeight;
    }
    return clientHeight;
};
exports.getWindowHeight = getWindowHeight;
const getElement = (elementParam) => {
    if (!elementParam)
        return null;
    let element = null;
    if (typeof elementParam === 'string') {
        element = window_or_global_1.default.document.getElementById(elementParam) || null;
    }
    else if (typeof elementParam === 'object' && elementParam.offsetWidth) {
        element = elementParam;
    }
    else {
        console.warn('getElement() could not obtain an element from the parameter passed. Requires an ID or a DOM node.');
    }
    return element;
};
exports.getElement = getElement;
const getOuterWidth = (elementParam) => {
    const element = exports.getElement(elementParam);
    const getMargin = (prop) => {
        if (!element || !prop) {
            return 0;
        }
        let marginValue = '';
        try {
            // Support for old versions of IE
            // @ts-ignore
            //eslint-disable-next-line
            const currentStyle = element.currentStyle || {};
            if (window_or_global_1.default.getComputedStyle) {
                const style = window_or_global_1.default.getComputedStyle(element) || {};
                marginValue = style.getPropertyValue(prop) || '0';
            }
            else if (currentStyle) {
                marginValue = currentStyle[prop];
            }
        }
        catch (e) {
            //Couldn't get margin
        }
        marginValue = marginValue.replace('px', '');
        return +marginValue;
    };
    let width = 0;
    if (element) {
        width = element.offsetWidth ? element.offsetWidth : 0;
        width += getMargin('margin-left');
        width += getMargin('margin-right');
    }
    return width;
};
exports.getOuterWidth = getOuterWidth;
const getInnerWidth = (elementParam) => {
    const element = exports.getElement(elementParam);
    let width = 0;
    if (element) {
        width = element.offsetWidth ? element.offsetWidth : 0;
    }
    return width;
};
exports.getInnerWidth = getInnerWidth;
/**
 * If the delta for the x or y coordinates of the mouse have changed from mouse down to mouse up
 *  it is dragging motion and not intended to be a click.
 * @param  {Object} e Event object
 * @return {Boolean}   true/false
 */
function draggingMotion(e, mouseDown) {
    const allowed = 40;
    const x = e.clientX;
    const y = e.clientY;
    if (mouseDown) {
        if (Math.abs(x - mouseDown.x) > allowed) {
            return true;
        }
        if (Math.abs(y - mouseDown.y) > allowed) {
            return true;
        }
    }
    return false;
}
exports.draggingMotion = draggingMotion;
const getBowserState = () => {
    let mobile;
    let tablet;
    let msie;
    let firefox;
    let ios;
    let msedge;
    let mac;
    let linux;
    if (window_or_global_1.default._epicGamesNav && window_or_global_1.default._epicGamesNav.browser) {
        mobile = window_or_global_1.default._epicGamesNav.browser.mobile;
        tablet = window_or_global_1.default._epicGamesNav.browser.tablet;
        msie = window_or_global_1.default._epicGamesNav.browser.msie;
        firefox = window_or_global_1.default._epicGamesNav.browser.firefox;
        ios = window_or_global_1.default._epicGamesNav.browser.ios;
        msedge = window_or_global_1.default._epicGamesNav.browser.msedge;
        mac = window_or_global_1.default._epicGamesNav.browser.mac;
        linux = window_or_global_1.default._epicGamesNav.browser.linux;
    }
    return {
        mobile: mobile || false,
        tablet: tablet || false,
        msie: msie || false,
        firefox: firefox || false,
        ios: ios || false,
        msedge: msedge || false,
        mac: mac || false,
        linux: linux || false
    };
};
exports.getBowserState = getBowserState;
function isMobile() {
    const epicGamesNavInfo = window_or_global_1.default._epicGamesNav;
    const browser = epicGamesNavInfo.browser;
    return browser && browser.mobile;
}
exports.isMobile = isMobile;
function isTablet() {
    const epicGamesNavInfo = window_or_global_1.default._epicGamesNav;
    const browser = epicGamesNavInfo.browser;
    return browser && browser.tablet;
}
exports.isTablet = isTablet;
function getDecimalSeparator() {
    let decSep = '.';
    try {
        const decimalNumber = 3 / 2;
        // this works in FF, Chrome, IE, Safari and Opera
        const sep = parseFloat(`${decimalNumber}`)
            .toLocaleString()
            .substring(1, 2);
        if (sep === '.' || sep === ',') {
            decSep = sep;
        }
    }
    catch (e) {
        console.warn('Failed to detect the decimal separator');
    }
    return decSep;
}
exports.getDecimalSeparator = getDecimalSeparator;
function convertStringToNumber(numericString) {
    const decSeparator = getDecimalSeparator();
    let numeric;
    //remove the thousand separator depending on language
    if (decSeparator === '.') {
        numeric = Math.floor(+numericString.replace(/,/, ''));
    }
    else if (decSeparator === ',') {
        numeric = Math.floor(+numericString.replace(/\./, ''));
    }
    else {
        numeric = Math.floor(+numericString);
    }
    return numeric;
}
exports.convertStringToNumber = convertStringToNumber;
//# sourceMappingURL=browser.js.map